import secondaryComponents from "..";
import useStockRemovalItemsTable from "./useStockRemovalItemsTable";

const StockRemovalItemsTable = ({
  items = [],
  removalDetails,
  setPreviewImage = () => {},
  onPreviewImage,
  className = "",
  style,
}) => {
  const { instance } = useStockRemovalItemsTable({
    items,
    removalDetails,
    setPreviewImage,
    onPreviewImage,
  });

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    instance;

  return (
    <div className={className} style={style}>
      <secondaryComponents.TableHelper
        getTableProps={getTableProps}
        getTableBodyProps={getTableBodyProps}
        headerGroups={headerGroups}
        rows={rows}
        prepareRow={prepareRow}
        minHeight="auto"
      >
        <div className="py-4 text-center">
          <p className="mb-0 text-muted">No items in this request</p>
        </div>
      </secondaryComponents.TableHelper>
    </div>
  );
};

export default StockRemovalItemsTable;
